export const API_RESPONSE_SUCCESS = "SUCCESS";
export const API_RESPONSE_FAILURE = "FAILURE";
export const API_KEY_DEPTHVALUE = "depthValue";
export const TRIGGERED_STRATEGIES_DEPLOYED = "strategiesDeployed";
export const TRIGGERED_SCALPING_DEPLOYED = "scalpingDeployed";
//link
export const TRADETRON_LINK = "https://5p.tradetron.tech/deployed";
//export const CWA_LINK = "https://infinity.compoundingwealth.co.in";
export const CWA_LINK = "https://dev-openapi.5paisa.com/WebVendorLogin/VLogin/Index?VendorKey=PsskhKk8KR6Ihq6OjOgr1hhCTwxvqpBj&ResponseURL=https://infinitysso.compoundingwealth.co.in/dashboard";
export const CWA_TERM_N_CONDITION_LINK = "https://www.5paisa.com/cwa-infinity-options-tnc-disclaimer";
//forum link
export const CWA_ADVANCE_STRATEGIES_FORUM_LINK = "https://forum.5paisa.com/portal/en/community/topic/introducing-automated-strategies";
export const SMART_STRATEGIES_FORUM_LINK = "https://forum.5paisa.com/portal/en/community/topic/introduction-to-smart-strategies-in-fno-360";
export const SMART_SCALPING_FORUM_LINK = "https://forum.5paisa.com/portal/en/community/topic/introduction-to-scalping-strategy-in-fno-360";
//dashboard description
export const SMART_OPTION_DESCRIPTION = "This tool will help you use Predefined strategies or create a custom strategy. You can see useful details for the strategy like Payoff Graph, Margin Required, Breakeven Range, Premium receivable or payable etc. You can smartly execute the strategy with defined entry and exit conditions. You can enter based on combined premium and exit on defined Target Profit/SL with or without trailing.";
export const SCALPING_OPTION_DESCRIPTION = "This tool will help you do Scalping Based on movement of Future Price Or Spot Price by simply entering underlying points UP/DOWN movement. You can definetype of Instrument , TGT and SL for each leg and no of times you want to do scalping. And Based on the inputs defined by you system will automatically enter and exit the strategy legs.";
export const ADVANCED_DESCRIPTION = "Advanced Strategies are a set of Automated Execution strategies which takes trades based on the pre build algorithm. The strategies are well designed to analyze the market condition and execute the trades automatically on behalf of you. All you have to do is Deploy the strategy.";
export const CWA_DESCRIPTION = "This is a suite of multiple non-coorelated Intra-day options strategies in Nifty and Banknifty with Pre-defined rules for Entry and Exit. It combines directional as well as non-directional positions aimed to achieve good risk-adjusted returns, with controlled drawdowns.";
//event listner key
export const EVENT_VISIBILITY_CHANGE = "visibilitychange";
//Pnl Report collapse Key
export const ENABLE_DROPDOWN = "enableDropdown";
export const DATA_TYPE_ALL = "ALL";
export const DATA_TYPE_SCALPING = "SCALPING";
//Location href
export const PNLREPORT_HREF = "/strategies/strategy-pl";
export const STRATEGIES_HREF = "/strategies";
//action item menu
export const ACTION_ITEM_MENU_BOOKED = "Booked";
export const ACTION_ITEM_MENU_STOP = "Stop";
export const ACTION_ITEM_MENU_STARTED = "Started";
export const ACTION_ITEM_MENU_EXECUTED = "Executed";
export const ACTION_ITEM_MENU_EXITED = "Exit";
//api call key
export const API_ACTION_ITEM_DELETE = "delete";
export const API_ACTION_ITEM_START = "start";
export const API_ACTION_ITEM_STOP = "stop";
export const API_ACTION_ITEM_SQUARE_OFF = "exit";
export const API_MODEL_TYPE_STRATEGIES = "all";
export const API_MODEL_TYPE_SCALPING = "scalping";
//criteria key
export const CRITERIA_TRAIL_PROFIT = "Trail Profit";
export const CRITERIA_TRAIL_LOSS = "Trailing StopLoss";
//exit parameter const
export const EXIT_PARAM_FIXED_PROFIT = "FixedProfit";
export const EXIT_PARAM_FIXED_LOSS = "FixedLoss";
export const EXIT_PARAM_TRAIL_VALUE = "TrailValue";
export const EXIT_PARAM_TYPE_PERCENT = "%";
//Instrumnet
export const INSTRUMENT_CE = "CE";
export const INSTRUMENT_PE = "PE";
export const INSTRUMENT_FUT = "FUT";
//Payoffchart
export const API_KEY_UNDEFINED = "Undefined";
export const API_KEY_UNLIMITED = "Unlimited";
export const MODAL_MESSAGE_PARAMETER = {
    exit: {
        title: "Confirmation To Square Off The Strategy",
        description: "All your existing positions taken by strategy will be squared off.",
        positiveText: "Yes, Square Off",
        negativeText: "No, Thanks",
        type: "exit",
    },
    stop: {
        title: "Confirmation To Stop The Strategy",
        description: "Your Strategy will stop checking for Entry and Exit Condition.",
        positiveText: "Yes, Stop",
        negativeText: "No, Thanks",
        type: "stop",
    },
    delete: {
        title: "Confirmation To Delete The Strategy",
        description: "Your strategy will be deleted and you no longer will be able to see it under P&L section.",
        positiveText: "Yes, Delete",
        negativeText: "No, Thanks",
        type: "delete",
    },
    start: {
        title: "Confirmation To Start The Strategy",
        description: "Your Strategy will start checking for Entry and Exit Condition.",
        positiveText: "Yes, Start",
        negativeText: "No, Thanks",
        type: "start",
    },
};
//legs constant kEY
export const LEGS_KEY_INSTRUMENT = "Instrument";
export const LEGS_KEY_STRIKEPRICE = "StrikePrice";
//Error Message
export const QTY_ERROR_MESSAGE = "Invalid Qty!";
//Scalping
export const LEGS_LEVEL_QTY = "LegLevelQuantity";
export const UNDERLYING_SPOTPOINTS = "Spot Points";
export const INTRUMENT_EQ = "EQ";
export const INTRUMENT_FUT = "FUT";
export const LEGS_LEVEL_INS = "LegLevelInstrument";
export const LEGLEVEL_BUY = "BUY";
export const LEGLEVEL_SELL = "SELL";
export const EXPIRY_DATE = "YYYY/MM/DD";
